import { useState } from "react";
import { Button } from "@mui/material";

import ReleasesView from "./ReleasesView";
import { ProjectConfigSchema } from "hooks/pavm/base";

const ReleasesDialog = ({
  type,
  config,
  disabled = false,
}: {
  type: string;
  disabled?: boolean;
  config: ProjectConfigSchema;
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        size="small"
        color="secondary"
        variant="contained"
        disabled={disabled}
        onClick={handleOpen}
      >
        {type}
      </Button>

      <ReleasesView
        type={type}
        title={config.host}
        config={config}
        open={open}
        onClose={handleClose}
      />
    </div>
  );
};

export default ReleasesDialog;
